<template>
  <div class="data-list">
    <div class="head-box">
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
          <el-form-item label="核对结果" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择" @change="onSearch">
              <el-option label="全部" value=""> </el-option>
              <el-option label="对账中" value="0"> </el-option>
              <el-option label="正常" value="1"> </el-option>
              <el-option label="异常" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核对时间" prop="updatedTime">
            <q-date-picker v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
      <!-- <div class="data-list-header">
        <div class="card-left">
          <el-row :gutter="10">
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  资金总结余
                  <el-tooltip class="item" effect="dark" content="=为下方筛选时间内所有活动数，包含“进行中”、“待开始”和“已结束”活动" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.inProgress}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header"> 活动总数</div>
                <div class="number">￥{{panelData.end}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">进行中活动</div>
                <div class="number">￥{{panelData.joinOrganization}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header"> 待开始活动</div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header"> 已结束活动</div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card :body-style="{ padding: '0' }">
                <div class="header"> "待核销+充值剩余"总资金</div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  待开始活动
                  <el-tooltip class="item" effect="dark" content="为下方筛选时间内，活动结余或营销活动数据中“结余余额”<0 <0或的订单数" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div> -->
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="goDetail(null)">查看全部异常明细</el-button>
          <el-button type="primary" size="small" @click="oneClickReconciliation">一键对账</el-button>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="updatedTime" label="核对时间" show-overflow-tooltip width="160"></el-table-column>
          <el-table-column prop="customer" label="核对周期" align="center" show-overflow-tooltip width="300">
            <template slot-scope="{ row }">
              {{ row.startTime ? row.startTime + " - " + row.endTime : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="reconciliationType" label="钱包类型" align="center">
            <template slot-scope="{ row }">
              {{ reconciliationTypeText[row.reconciliationType] || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="total" label="核对经销商钱包总数" align="center"></el-table-column>
          <el-table-column prop="outlierTotal" label="异常经销商钱包数" align="center"></el-table-column>
          <el-table-column prop="joinNum" label="核对结果" align="center">
            <template slot-scope="{ row }">
              <span :style="`${row.status == 2 ? 'color: red' : ''}`">{{ row.statusString }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinNum" label="操作" align="center" width="140">
            <template slot-scope="{ row }">
              <el-button type="text" @click="goDetail(row)" v-if="row.status == 2">查看异常明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin';
import moment from "moment";
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        code: "",
        status: "",
        parentIdCode: "",
        startTime: "",
        endTime: "",
      },
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      activeName: "first",
      status2Text: {
        0: "对账中",
        1: "活动全部正常",
        2: "存在活动异常",
      },
      reconciliationTypeText: {
        3: "老钱包",
        4: "新钱包",
        5: "老钱包",
        6: "新钱包",
      },
      searchFormData: {},
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          type: 5,
        },
      };
      this.searchFormData = params.filterData;
      this.$api.dataReport
        .reconciliationPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    async oneClickReconciliation() {
      let status = await this.$confirm(`是否确认一键对账？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let { startTime, endTime } = this.filterParam;
      let data = {
        startTime,
        endTime,
      }
      this.$api.dataReport.cusReconciliation(data).then((res) => {
        if (res.success) {
          this.$message.success(`一键对账成功`);
        } else {
          this.$message.error(`一键对账失败`);
        }
        this.onSearch();
      });
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    goDetail(row) {
      this.openSubPage({ path: "/dataReport/dealer-data-details", query: row ? { ...row } : {} });
    },
    handleAdd(row, actionType) {
      let params = {
        ...this.searchFormData,
      };
      this.$api.common.doExport("reconciliationPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    tabHeightSum() {
      this.addListener();
      this.setMaxHeight();
      this.$bus.$on('table.updateHeight', (offset) => {
        this.setMaxHeight(offset || 0);
      });
    },
    jumpRecord() {
      this.openSubPage({
        path: "/dataReport/activity-record",
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .head-box {
    margin: 0 15px;
    padding: 10px;
    padding-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid #ccc;
    }
    .number {
      height: 50px;
      text-align: center;
      line-height: 50px;
      text-align: center;
    }
    .card {
      padding: 10px;
      .title {
        padding: 6px 0;
        color: #fff;
        text-align: center;
        border-radius: 4px;
        background: #0BB78E;
      }
      .middle {
        display: flex;
        margin-top: 4px;
        .item {
          width: 50%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          align-items: center;
          color: #fff;
          border-radius: 4px;
          background: #0BB78E;
        }
        .line {
          color: #0BB78E;
          height: 30px;
          line-height: 30px;
          margin: 0 10px;
        }
      }
      .tips {
        text-align: center;
        margin-top: 4px;
      }
    }
  }
}
</style>
